import React, {useEffect, useState} from 'react';
import {
  DialogContentText,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  InputLabel,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AddIcon from '@material-ui/icons/Add';
import {read, utils, writeFile} from 'xlsx';

import UploadIcon from '@material-ui/icons/CloudUpload';
import useStyles from './styles';

import {CloudDownload, Edit, Save} from '@material-ui/icons';
import EditListItem from './editList';
import {useSnackbar} from 'notistack';
import Confirm from '../../../../components/Confirm';
import ButtonSubmit from '../../../../components/forms/ButtonSubmit';
import api from '../../../../core/api';
import {validateEmail} from '../../../../utils/validateEmail';

const UploadUsers = ({id, openSendUsers, setOpenSendUsers}) => {
  const classes = useStyles();
  const {enqueueSnackbar} = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [users, setUsers] = useState([]);
  const [sendConfirm, setSendConfirm] = useState(false);

  const handleImport = $event => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = async event => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          setUsers(rows);
          // verificarDuplicados();
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleExport = () => {
    const headings = [['Nome', 'Email']];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, users, {origin: 'A2', skipHeader: true});
    utils.book_append_sheet(wb, ws, 'Report');
    writeFile(wb, 'Modelo upload de usuários.xlsx');
  };

  async function onSubmit() {
    if (editable) {
      setEditable(false);
      return;
    }

    let statusOk = true;
    const payload = users.map(user => {
      if (statusOk) {
        if (!user.Email) {
          enqueueSnackbar('Campo email não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        if (!validateEmail(user.Email)) {
          enqueueSnackbar(`Email ${user.Email} inválido.`, {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        if (!user.Nome) {
          enqueueSnackbar('Campo nome não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        return {
          email: user.Email.trim(),
          name: user.Nome,
        };
      }
    });

    if (statusOk) {
      // console.log(payload);
      const res = await Confirm(
        'Deseja realmente enviar Newsletter para esses usuários?',
      );

      if (res) {
        setIsLoading(true);
        try {
          await api.post(`/newsletter/send-email-users/${id}`, payload);
          setSendConfirm(true);
        } catch ({response}) {
          enqueueSnackbar(response.data?.payload.message, {
            variant: 'error',
          });
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      }
    }
  }

  const CloseModal = () => {
    setOpenSendUsers(false);
    setSendConfirm(false);
    setIsLoading(false);
    setUsers([]);
  };

  return (
    <Dialog
      onClose={CloseModal}
      open={openSendUsers}
      fullWidth={true}
      maxWidth={'md'}>
      <DialogTitle id="simple-dialog-title" style={{textAlign: 'center'}}>
        Enviar Newsletter para usuários selecionados
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="center">
          {isLoading ? (
            <div className="flex-col center-a center-b">
              <DialogTitle id="simple-dialog-title">
                Enviando Newsletter!!
              </DialogTitle>
              <CircularProgress size={50} />
              <p> Aguarde... </p>
            </div>
          ) : sendConfirm ? (
            <div className="flex-col center-a center-b" style={{margin: 20}}>
              <CheckCircleIcon style={{color: 'green'}} />
              <DialogTitle id="simple-dialog-title">
                Newsletter enviada!!
              </DialogTitle>
              <p>
                Em caso de erro, todos devem verificar a caixa de entrada e
                pasta de spam.
              </p>
            </div>
          ) : (
            <div className={classes.uploadsScreen}>
              <div className={classes.titleContainer}>
                <div className={classes.uploadBar}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}>
                    <InputLabel>Baixar exemplo</InputLabel>
                    <IconButton
                      variant="contained"
                      component="label"
                      onClick={handleExport}>
                      <CloudDownload />
                    </IconButton>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: 20,
                    }}>
                    <InputLabel>Subir excel</InputLabel>
                    <IconButton variant="contained" component="label">
                      <UploadIcon />
                      <input
                        type="file"
                        className={classes.fileInput}
                        required
                        onChange={handleImport}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    </IconButton>
                  </div>

                  {users.length ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: 20,
                      }}>
                      <InputLabel>{`${
                        editable ? 'Ver' : 'Editar'
                      } campos`}</InputLabel>
                      <IconButton
                        variant="contained"
                        component="label"
                        onClick={() => setEditable(!editable)}>
                        {editable ? <Save /> : <Edit />}
                      </IconButton>
                    </div>
                  ) : null}

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: 20,
                    }}>
                    <InputLabel>Adicionar</InputLabel>
                    <IconButton
                      variant="contained"
                      component="label"
                      onClick={() => {
                        const newUser = [
                          ...users,
                          {
                            Email: '',
                            Nome: '',
                          },
                        ];
                        setUsers(newUser);
                        setEditable(true);
                      }}>
                      <AddIcon />
                    </IconButton>
                  </div>
                </div>
              </div>

              <div className={classes.mediaItems}>
                {!isLoading ? (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Nome</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      {users && users.length > 0 && (
                        <EditListItem
                          users={users}
                          editable={editable}
                          setUsers={setUsers}
                        />
                      )}
                    </Table>
                    {users.length ? (
                      <ButtonSubmit
                        loadingArea={isLoading}
                        style={{marginTop: 20}}
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}>
                        Salvar
                      </ButtonSubmit>
                    ) : null}
                  </>
                ) : (
                  <div
                    className="flex-col center-a center-b"
                    style={{height: '50vh'}}>
                    <span
                      style={{paddingTop: '10em', justifyContent: 'center'}}>
                      <CircularProgress size={100} />
                      <p> Salvando dados... </p>
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default UploadUsers;
